<template>
  <b-modal
    id="modal-salary-record"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    scrollable
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
    <template #modal-header="{ close }">
      <h3 class="m-0">
        {{ newSalaryRecordData.id > 0 ? "修改" : "新增" }}出糧記錄
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12" md="12">
              <div
                class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
              >
                <label>曾工作地點：</label>
                <div class="input_wrap">
                  <validation-provider
                    #default="validationContext"
                    name="此欄"
                    rules="required"
                    vid="v_address"
                  >
                    <b-form-input
                      id="sr_address"
                      v-model="newSalaryRecordData.address"
                      placeholder="曾工作地點"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
              </div>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_join_dates"
              >
                <b-form-group
                  label="開工日期："
                  label-for="join_dates"
                  label-cols-md="3"
                >
                  <flat-pickr
                    v-model="newSalaryRecordData.join_dates"
                    class="form-control"
                    :config="{
                      mode: 'multiple',
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_payment_method_id"
              >
                <b-form-group
                  label="計薪形式："
                  label-for="payment_method_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="payment_method_id"
                    v-model="newSalaryRecordData.payment_method_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="paymentMethodStatusOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇計薪形式"
                    :filter="paymentMethodSearch"
                  >
                  </v-select>

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_position"
              >
                <b-form-group
                  label="職位："
                  label-for="position"
                  label-cols-md="3"
                  :class="required"
                >
                  <b-form-input
                    id="position"
                    v-model="newSalaryRecordData.position"
                    placeholder="輸入職位"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_salary"
              >
                <b-form-group
                  label="出糧薪金："
                  label-for="salary"
                  label-cols-md="3"
                  :class="required"
                >
                  <b-form-input
                    id="salary"
                    v-model="newSalaryRecordData.salary"
                    placeholder="輸入出糧薪金"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <upload-file v-on:file-uploaded="onFileUploaded"></upload-file>
            </b-col>
          </b-row>
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              class="mr-1"
              @click="hide"
            >
            取消
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
            >
              <font-awesome-icon
                class="mr-25"
                icon="fa-solid fa-circle-check"
              />
              提交
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import workerStoreModule from "../workerStoreModule";
import store from "@/store";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFile
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
    salaryRecordData: {
      type: Object,
      required: true,
    },
    user_id: {}
  },
  data() {
    return {
      required,
      dragAndDropCapable: false,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-salary-record");
    },
    onFileUploaded(file){
      this.newSalaryRecordData.image_files = file
    },
    paymentMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      if (this.newSalaryRecordData.id == 0 && this.newSalaryRecordData.file)
        return;

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();

          formData.append("id", this.newSalaryRecordData.id);
          formData.append("address", this.newSalaryRecordData.address);
          formData.append("join_dates", this.newSalaryRecordData.bank_account);
          formData.append("user_id", this.newSalaryRecordData.user_id ? this.newSalaryRecordData.user_id : this.user_id);
          formData.append(
            "payment_method_id",
            this.newSalaryRecordData.payment_method_id
          );
          formData.append("position", this.newSalaryRecordData.position);
          formData.append("salary", this.newSalaryRecordData.salary);

          if (this.newSalaryRecordData.file) {
            if (this.newSalaryRecordData.file.size >= 2097152) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error! Your Image size is larger then 2M",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              return false;
            } else {
              formData.append("file", this.newSalaryRecordData.file);
            }
          }

          this.loading = true;
          store
            .dispatch("worker/updateSalaryRecord", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const SALARY_STORE_MODULE_NAME = "worker";

    // Register module
    if (!store.hasModule(SALARY_STORE_MODULE_NAME))
      store.registerModule(SALARY_STORE_MODULE_NAME, workerStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SALARY_STORE_MODULE_NAME))
        store.unregisterModule(SALARY_STORE_MODULE_NAME);
    });

    const loading = ref(false);
    const newSalaryRecordData = ref({ id: 0 });

    const resetSalaryRecordData = () => {
      props.salaryRecordData = JSON.parse(JSON.stringify({ id: 0 }));
    };

    watch(
      () => props.salaryRecordData,
      (newVal) => {
        newSalaryRecordData.value = { ...newVal };
      }
    );

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetSalaryRecordData
    );

    return {
      loading,
      newSalaryRecordData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
#modal-salary-record {
  .full_input label {
    width: calc(13% - 3px);
  }
}
</style>
